import type { MouseEvent, ReactNode } from "react";
import { isPlainNavClick } from "@/platform/lib/nav";
import { LensMark } from "./LensMark";

// The shared application header: the Keylens brand plus a slot for surface-specific actions. The
// board view fills the slot with its action cluster (Compare, toggles, download, share); the
// Compendium leaves it empty. TheCore's door is no longer a primary-nav lockup here; it now lives as
// a contextual chip on the Profile control (LearnTheCore), shown when a TheCore Preset is active. The
// brand is a real <a href> so it stays crawlable and new-tab-able, progressively enhanced to
// client-side navigation via the injected onNavigate (the same router-decoupling seam the board view
// uses): no router context is required, so the header mounts standalone (tests) or routed alike.
export function AppHeader({
  onNavigate,
  children,
}: {
  onNavigate?: (to: string) => void;
  children?: ReactNode;
}) {
  const go = (to: string) => (e: MouseEvent) => {
    if (onNavigate && isPlainNavClick(e)) {
      e.preventDefault();
      onNavigate(to);
    }
  };
  return (
    <header className="topbar">
      <a href="/" className="brand" aria-label="Keylens home" onClick={go("/")}>
        <span className="brand-mark">
          <LensMark />
        </span>
        <span className="brand-name">
          Key<span className="brand-thin">lens</span>
        </span>
      </a>
      {children ? <span className="board-pick">{children}</span> : null}
    </header>
  );
}
